import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, styled } from '@mui/material';

export const HeaderDiv = styled('div', {
  shouldForwardProp: (prop) =>
    prop !== 'isCardMobileList' && prop !== 'isCardMobileDetails',
})(({ isCardMobileList, isCardMobileDetails }) => {
  const getDisplay = () => {
    if (isCardMobileList || isCardMobileDetails)
      return {
        display: 'block',
      };

    return {
      display: 'grid',
      gridTemplateAreas: `
    "favoriteIcon stockName"
    ". securityInfo"
    `,
      gridColumnGap: '24px',
      alignItems: 'center',
      alignContent: 'center',
    };
  };

  return {
    width: 'auto',
    ...getDisplay(),
  };
});

export const UpperContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '6px',
  [theme.breakpoints.up('md')]: {
    gap: '8px',
  },
}));

export const FavoriteIcon = styled(FontAwesomeIcon, {
  shouldForwardProp: (prop) =>
    prop !== 'disabled' &&
    prop !== 'isCardMobileList' &&
    prop !== 'isCardMobileDetails',
})(({ theme, disabled, isCardMobileList, isCardMobileDetails }) => ({
  color: disabled ? theme.palette.colors.lower : theme.palette.colors.star,
  width: isCardMobileList || isCardMobileDetails ? '18px' : '27px',
  height: isCardMobileList || isCardMobileDetails ? '16px' : '24px',
  gridArea: 'favoriteIcon',
  cursor: 'pointer',
  [theme.breakpoints.up('md')]: {
    width: isCardMobileList && '21px',
    height: isCardMobileList && '18px',
  },
}));

export const Separator = styled('div')(({ theme }) => ({
  width: '1px',
  height: '12px',
  backgroundColor: theme.palette.colors.lower,
  margin: '0 4px',
  [theme.breakpoints.up('md')]: {
    margin: '0 8px',
  },
}));

export const StockNameContainer = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== 'isCardMobileList' && prop !== 'isCardMobileDetails',
})(({ theme, isCardMobileList, isCardMobileDetails }) => {
  const getMaxWidth = () => {
    if (isCardMobileList)
      return {
        maxWidth: '296px',
        [theme.breakpoints.up('md')]: {
          maxWidth: '542px',
        },
        [theme.breakpoints.up('xl')]: {
          maxWidth: '250px',
        },
        [theme.breakpoints.up('xxl')]: {
          maxWidth: '350px',
        },
      };

    if (isCardMobileDetails)
      return {
        maxWidth: '270px',
        [theme.breakpoints.up('md')]: {
          maxWidth: '340px',
        },
      };

    return {
      maxWidth: '220px',
      [theme.breakpoints.up('xl')]: {
        maxWidth: '250px',
      },
      [theme.breakpoints.up('xxl')]: {
        maxWidth: '350px',
      },
    };
  };

  return {
    gridArea: 'stockName',
    display: 'flex',
    ...getMaxWidth(),
  };
});

export const StockName = styled('span')(({ theme }) => ({
  fontWeight: 'bold',
  fontSize: '18px',
  color: theme.palette.colors.onSecondaryAndDetailBackground,
  textTransform: 'uppercase',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  [theme.breakpoints.up('md')]: {
    fontSize: 24,
  },
}));

export const StockInfo = styled('div', {
  shouldForwardProp: (prop) =>
    prop !== 'isOrder' && prop !== 'isCardMobileList',
})(({ theme, isOrder, isCardMobileList }) => ({
  display: 'flex',
  alignItems: 'center',
  fontWeight: 500,
  fontSize: '10px',
  color: theme.palette.colors.onSecondaryAndDetailBackground,
  marginBottom: isOrder ? '10px' : 5,
  textTransform: 'uppercase',
  gridArea: 'securityInfo',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  [theme.breakpoints.up('md')]: {
    fontSize: '12px',
    marginBottom: isOrder ? 16 : 5,
    marginTop: isOrder ? 4 : 0,
    maxWidth: isCardMobileList && 'unset',
  },
}));
